import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { External } from '@/icons/External'

import * as S from './FormInfo.styles'

const FormInfo = ({ title, text = '', color, link }) => (
  <Flex direction="column" gap="$2">
    <FloraTypography fontSize="bodyLargeStandard" css={S.labelCss}>
      {title}
    </FloraTypography>
    <Flex align="center" direction="row" gap="$2">
      <FloraTypography fontSize="bodyLargeStandard" css={S.getDynamicColorCss(color)}>
        {text}
      </FloraTypography>
      {link && (
        <Box as="a" href={link} rel="noopener noreferrer" target="_blank">
          <External />
        </Box>
      )}
    </Flex>
  </Flex>
)

export default FormInfo
